<template>
<div class="chapter">
<div class="inner_page">
<p class="txc1" id="p0007-02-1"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><i>Me: Gracie, what should I write here? <br/>Grace: Mommeee, yooo shud wite “I lub you!” <br/>Me: That’s a great idea, sweet pea! I love you, Grace.</i></span></p>
<div class="figbody"><img alt="978071802239_0007_003.jpg" id="p0007-d6e31" src="images/978071802239_0007_003.jpg"/><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?20efade2